import { render, staticRenderFns } from "./AvatarSandwich.vue?vue&type=template&id=fcb0e9ea&scoped=true&"
import script from "./AvatarSandwich.vue?vue&type=script&lang=js&"
export * from "./AvatarSandwich.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSandwich.vue?vue&type=style&index=0&id=fcb0e9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0e9ea",
  null
  
)

export default component.exports